const listColumn = {
  TICKER: 'stockScreenerItem.ticker',
  SECTOR: 'stockScreenerItem.icbCode',
  CLOSE_PRICE: 'stockScreenerItem.closePrice',
  RTD36: 'stockScreenerItem.rtd36',
  RTD20: 'stockScreenerItem.rtd20',
  RTD20AVG: 'stockScreenerItem.rtd20Avg',
  RTD21: 'stockScreenerItem.rtd21',
  RTD11: 'stockScreenerItem.rtd11',
  AVERAGE_VOLUME_3MONTH: 'stockScreenerItem.averageVolume3Month',
  OVER_SMA50: 'stockScreenerItem.overSma50',
  ORGANIZATION_OWNERSHIP: 'stockScreenerItem.organizationOwnership',
  RTD14: 'stockScreenerItem.rtd14',
  RTD25: 'stockScreenerItem.rtd25',
  RTD52: 'stockScreenerItem.rtd52',
  RTQ12: 'stockScreenerItem.rtq12',
  RYQ160: 'stockScreenerItem.ryq160',
  RYQ166: 'stockScreenerItem.ryq166',
  RYQ176: 'stockScreenerItem.ryq176',
  RSI: 'technical.rsi',
  RQD25: 'stockScreenerItem.rqd25',
  RYD52: 'stockScreenerItem.ryd52',
  GROWTH: 'stockScreenerItem.growth',
  MOMENTUM: 'stockScreenerItem.momentum',
  VALUE: 'stockScreenerItem.value',
  VGM: 'stockScreenerItem.vgm',
  ICBRANK: 'stockScreenerItem.icbRank',
  ICBRANK_TOTAL: 'stockScreenerItem.icbTotalRanked',
  INDEXRANK: 'stockScreenerItem.indexRank',
  CAPITAL_STRUCTURE: 'stockScreenerItem.capitalStructure',
  CFO: 'stockScreenerItem.cfo',
  DEBT: 'stockScreenerItem.debt',
  EQUITY_INSSURANCE: 'stockScreenerItem.equityInssurance',
  FINANCIAL_PLAN: 'stockScreenerItem.financialPlan',
  FINANCIAL_STRENGTH: 'stockScreenerItem.financialStrength',
  GROSSMARGIN: 'stockScreenerItem.grossMargin',
  PROFIT_GROWTH: 'stockScreenerItem.profitGrowth',
  REVENUE_GROWTH: 'stockScreenerItem.revenueGrowth',
  ROE: 'stockScreenerItem.roe',
  ROA: 'stockScreenerItem.rtq14',
  RTD26: 'stockScreenerItem.rtd26',
  RTD28: 'stockScreenerItem.rtd28',
  RTD40: 'stockScreenerItem.rtd40',
  RTD27: 'stockScreenerItem.rtd27',
  TOTALMATCHVOLUME: 'stockScreenerItem.totalMatchVolume',
  AVERAGEVOLUME2WEEK: 'stockScreenerItem.averageVolume2Week',
  PERCENTPRICECHANGE1DAY: 'stockScreenerItem.percentPriceChange1Day',
  PERCENTPRICECHANGE1WEEK: 'stockScreenerItem.percentPriceChange1Week',
  PERCENTPRICECHANGE1MONTH: 'stockScreenerItem.percentPriceChange1Month',
  PERCENTPRICECHANGE3MONTH: 'stockScreenerItem.percentPriceChange3Month',
  PERCENTPRICECHANGE6MONTH: 'stockScreenerItem.percentPriceChange6Month',
  PERCENTPRICECHANGE52WEEK: 'stockScreenerItem.percentPriceChange52Week',
  PERCENTPRICECHANGEYTD: 'stockScreenerItem.percentPriceChangeYTD',
  SMA20: 'technical.sma20',
  SMA50: 'technical.sma50',
  SMA100: 'technical.sma100',
  AVERAGEVOLUME1WEEK: 'stockScreenerItem.averageVolume1Week',
  AVERAGEVOLUME1MONTH: 'stockScreenerItem.averageVolume1Month',
  RTD19: 'stockScreenerItem.rtd19',
  FREE_FLOAT_RATE: 'stockScreenerItem.freeFloatRate',
  REVTTM: 'financial.isa3',
  ISA20TTM: 'financial.isa20',
  RTQ25: 'stockScreenerItem.rtq25',
  RTQ29: 'stockScreenerItem.rtq29',
  RTQ2: 'stockScreenerItem.rtq2',
  RTQ3: 'stockScreenerItem.rtq3',
  RTQ4: 'stockScreenerItem.rtq4',
  RTQ6: 'stockScreenerItem.rtq6',
  REVY: 'stockScreenerItem.revY',
  ISA20Y: 'stockScreenerItem.isa20Y',
  RYQ25: 'stockScreenerItem.ryq25',
  RYQ29: 'stockScreenerItem.ryq29',
  RYQ2: 'stockScreenerItem.ryq2',
  RYQ3: 'stockScreenerItem.ryq3',
  RYQ4: 'stockScreenerItem.ryq4',
  RYQ6: 'stockScreenerItem.ryq6',
  RTD43: 'stockScreenerItem.rtd43',
  RTD36AVG: 'stockScreenerItem.rtd36Avg',
  RTD51: 'financial.rtd51',
  MA9: 'stockScreenerItem.ma9',
  MA20: 'stockScreenerItem.ma20',
  MA50: 'stockScreenerItem.ma50',
  MA75: 'stockScreenerItem.ma75',
  MA100: 'stockScreenerItem.ma100',
  MA200: 'stockScreenerItem.ma200',
  ADX: 'stockScreenerItem.adx',
  CCI: 'stockScreenerItem.cci',
  ROC: 'stockScreenerItem.roc',
  STOCHASTIC: 'stockScreenerItem.stochastic',
  WILLIAMS: 'stockScreenerItem.williams',
  MFI: 'stockScreenerItem.mfi',
  TOTALMATCHVALUE: 'stockScreenerItem.totalMatchValue',
  AVERAGEVALUE1WEEK: 'stockScreenerItem.averageValue1Week',
  AVERAGEVALUE2WEEK: 'stockScreenerItem.averageValue2Week',
  AVERAGE_VALUE_1MONTH: 'stockScreenerItem.averageValue1Month',
  AVERAGEVALUE3MONTH: 'stockScreenerItem.averageValue3Month',
  RTQ78: 'stockScreenerItem.rtq78',
  RTQ83: 'stockScreenerItem.rtq83',
  RTQ27: 'stockScreenerItem.rtq27',
  RQQ27: 'stockScreenerItem.rqq27',
  RQQ29: 'stockScreenerItem.rqq29',
  RQQ25: 'stockScreenerItem.rqq25',
  F_SCORE: 'stockScreenerItem.fScore',
  CANSLIM: 'stockScreenerItem.canslim',
  RTQ1: 'stockScreenerItem.rtq1',
  RTQ77: 'stockScreenerItem.rtq77',
  ForeignerRoom: 'stockScreenerItem.foreignerRoom',
  ForeignerPercentage: 'stockScreenerItem.foreignerPercentage',
  CorpOwnership: 'stockScreenerItem.corpOwnership',
  RTQ79: 'stockScreenerItem.rtq79',
  RTQ7: 'stockScreenerItem.rtq7',
  RQQ6: 'stockScreenerItem.rqq6',
  RQQ23: 'stockScreenerItem.rqq23',
};

const listHideColumn = [
  'stockScreenerItem.rqq23',
  'stockScreenerItem.rtq7',
  'stockScreenerItem.rqq6',
  'stockScreenerItem.rtq79',
  'stockScreenerItem.foreignerRoom',
  'stockScreenerItem.foreignerPercentage',
  'stockScreenerItem.corpOwnership',
  'stockScreenerItem.rtd20',
  'stockScreenerItem.rtd20Avg',
  'stockScreenerItem.rtq78',
  'stockScreenerItem.rtq83',
  'stockScreenerItem.rtd21',
  'stockScreenerItem.rtd11',
  'stockScreenerItem.rtd36',
  'stockScreenerItem.averageVolume3Month',
  'stockScreenerItem.closePrice',
  'stockScreenerItem.overSma50',
  'stockScreenerItem.organizationOwnership',
  'stockScreenerItem.organizationOwnership',
  'stockScreenerItem.averageValue1Month',
  'stockScreenerItem.rtd14',
  'stockScreenerItem.rtd19',
  'stockScreenerItem.rtd55',
  'stockScreenerItem.rtq12',
  'stockScreenerItem.rtq160',
  'technical.rsi',
  'stockScreenerItem.rqd25',
  'stockScreenerItem.rtd52',
  'stockScreenerItem.freeFloatRate',
  'stockScreenerItem.growth',
  'stockScreenerItem.momentum',
  'stockScreenerItem.value',
  'stockScreenerItem.vgm',
  'stockScreenerItem.icbRank',
  'stockScreenerItem.indexRank',
  'stockScreenerItem.capitalStructure',
  'stockScreenerItem.cfo',
  'stockScreenerItem.debt',
  'stockScreenerItem.equityInssurance',
  'stockScreenerItem.financialPlan',
  'stockScreenerItem.financialStrength',
  'stockScreenerItem.grossMargin',
  'stockScreenerItem.profitGrowth',
  'stockScreenerItem.revenueGrowth',
  'stockScreenerItem.roe',
  'stockScreenerItem.rtq14',
  'stockScreenerItem.rtd26',
  'stockScreenerItem.rtd28',
  'stockScreenerItem.rtd40',
  'stockScreenerItem.rtd27',
  'stockScreenerItem.rtq166',
  'stockScreenerItem.rtq176',
  'stockScreenerItem.totalMatchVolume',
  'stockScreenerItem.averageVolume2Week',
  'stockScreenerItem.percentPriceChange1Day',
  'stockScreenerItem.percentPriceChange1Week',
  'stockScreenerItem.percentPriceChange1Month',
  'stockScreenerItem.percentPriceChange3Month',
  'stockScreenerItem.percentPriceChange6Month',
  'stockScreenerItem.percentPriceChange52Week',
  'stockScreenerItem.percentPriceChangeYTD',
  'technical.sma20',
  'technical.sma50',
  'technical.sma100',
  'stockScreenerItem.averageVolume1Week',
  'stockScreenerItem.averageVolume1Month',
  'stockScreenerItem.averageVolume3Month',
  'financial.isa3',
  'financial.isa20',
  'stockScreenerItem.rtq25',
  'stockScreenerItem.rtq29',
  'stockScreenerItem.rtq2',
  'stockScreenerItem.rtq3',
  'stockScreenerItem.rtq4',
  'stockScreenerItem.rtq6',
  'stockScreenerItem.revY',
  'stockScreenerItem.isa20Y',
  'stockScreenerItem.ryq25',
  'stockScreenerItem.ryq29',
  'stockScreenerItem.ryq2',
  'stockScreenerItem.ryq3',
  'stockScreenerItem.ryq4',
  'stockScreenerItem.ryq6',
  'stockScreenerItem.rtd43',
  'stockScreenerItem.rtd36Avg',
  'financial.rtd51',
  'stockScreenerItem.ma9',
  'stockScreenerItem.ma20',
  'stockScreenerItem.ma50',
  'stockScreenerItem.ma75',
  'stockScreenerItem.ma100',
  'stockScreenerItem.ma200',
  'stockScreenerItem.adx',
  'stockScreenerItem.cci',
  'stockScreenerItem.roc',
  'stockScreenerItem.stochastic',
  'stockScreenerItem.williams',
  'stockScreenerItem.value',
  'stockScreenerItem.growth',
  'stockScreenerItem.momentum',
  'stockScreenerItem.vgm',
  'stockScreenerItem.totalMatchValue',
  'stockScreenerItem.averageValue1Week',
  'stockScreenerItem.averageValue2Week',
  'stockScreenerItem.averageValue1Month',
  'stockScreenerItem.averageValue3Month',
  'stockScreenerItem.rtd25',
  'stockScreenerItem.mfi',
  'stockScreenerItem.icbTotalRanked',
  'stockScreenerItem.ryq160',
  'stockScreenerItem.ryq166',
  'stockScreenerItem.ryq176',
  'stockScreenerItem.ryd52',
  'stockScreenerItem.rtq27',
  'stockScreenerItem.rqq27',
  'stockScreenerItem.rqq29',
  'stockScreenerItem.rqq25',
  'stockScreenerItem.fScore',
  'stockScreenerItem.canslim',
  'stockScreenerItem.rtq1',
  'stockScreenerItem.rtq77',
];

export default {
  listColumn,
  listHideColumn,
};
